/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {Box, Spinner, useStyleConfig} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'

const LoadingSpinner = ({wrapperStyles = {}, spinnerStyles = {}}) => {
    const styles = useStyleConfig('LoadingSpinner')
    const intl = useIntl()

    const loadingMessage = intl.formatMessage({
        id: 'loading.spinner.message',
        defaultMessage: 'Loading content, please wait',
    })

    return (
        <Box {...styles.wrapper} {...wrapperStyles}>
            <Spinner
                aria-live="polite"
                role="status"
                aria-label={loadingMessage}
                data-testid="loading"
                {...styles.spinner}
                {...spinnerStyles}
            />
        </Box>
    )
}

LoadingSpinner.propTypes = {
    wrapperStyles: PropTypes.object,
    spinnerStyles: PropTypes.object,
}

export default LoadingSpinner
